var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPricesIcon = function SvgPricesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#828282;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M136.007,324.118a8,8,0,1,0,8,8A8.009,8.009,0,0,0,136.007,324.118Zm0,14.4a6.4,6.4,0,1,1,6.4-6.4A6.407,6.407,0,0,1,136.007,338.518Z",
    transform: "translate(-128.007 -324.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M182.188,360.039h-.007a2.535,2.535,0,0,0-1.861.7,2.607,2.607,0,0,0-.71,1.776v1.1h-.7v1.586h.7v1.113a1.46,1.46,0,0,1-.128.547.558.558,0,0,1-.585.337v1.586h5.867V367.2h-3.684a2.971,2.971,0,0,0,.147-.886v-1.111h1.713v-1.586h-1.713V362.5a.843.843,0,0,1,.957-.878.939.939,0,0,1,1.042.924v.073h1.617v-.094A2.517,2.517,0,0,0,182.188,360.039Z",
    transform: "translate(-173.84 -356.409)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPricesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prices-icon.de96b429.svg";
export { ForwardRef as ReactComponent };